import script from "./RouteDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteDetail.vue?vue&type=script&setup=true&lang=ts"

import "./RouteDetail.vue?vue&type=style&index=0&id=08e87e5a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08e87e5a"]])

export default __exports__